/**
 * @copyright (C) 2023, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author
 * Jinhyoung Jang (jangjh@rsupport.com)
 *
 * @description
 *
 * @created at Tue Feb 28 2023
 **/

import React from "react";
import { css } from "@emotion/react";

interface ContainerProps {
	children?: React.ReactNode;
}

export default function Container(props: ContainerProps) {
	return <div css={ContainerCSS}>{props.children}</div>;
}

const ContainerCSS = css`
	min-height: 100vh;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	font-size: 1.125rem; // calc(10px + 2vmin);
	padding: 5px;
`;
